module.exports = __webpack_public_path__ + "static/img/gift-box-close.b7523b5e.png";